module.exports = __webpack_public_path__ + "static/media/5DPO16.bfcfd1f5.jpg";